import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Observable } from 'rxjs';
import { VerificationStatus } from '../models/verification-status.model';

@Injectable({
  providedIn: 'root'
})
export class VerificationService extends ApiBaseService {

  getStatus(code: string): Observable<{ status: string; data: VerificationStatus }> {
    return this.get<{ status: string; data: VerificationStatus }>(`/comercio/verification-status/${code}`);
  }

  complete(code: string): Observable<any> {
    return this.post('/comercio/solicitud/complete', { verification_code: code });
  }

  validateSignaturaReturn(token: string): Observable<any> {
    return this.get<any>(`/comercio/signatura/validate-return?token=${encodeURIComponent(token)}`);
  }
}
